(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-details"] && !Shopify.designMode) return;
  try {
    const initDetails = (root) => root.querySelectorAll('.product-details__list').forEach((list) => list.setAttribute('data-js', ''));
  initDetails(document);
  document.addEventListener('shopify:section:load', (event) => initDetails(event.target));
  document.addEventListener('click', (event) => {
    const summary = event.target.closest('[data-details] > summary');
    if (!summary) return;
    event.preventDefault();
    const item = summary.parentElement;
    const body = item.querySelector('.product-details__body');
    if (item.hasAttribute('open') && item.classList.contains('is-open')) {
      item.classList.remove('is-open');
      let done = false;
      const finish = () => { if (!done) { done = true; if (!item.classList.contains('is-open')) item.removeAttribute('open'); } };
      body.addEventListener('transitionend', finish, { once: true });
      setTimeout(finish, 400);
    } else {
      item.setAttribute('open', '');
      requestAnimationFrame(() => requestAnimationFrame(() => item.classList.add('is-open')));
    }
  });
  } catch(e) { console.error(e); }
})();

})();
